// extracted by mini-css-extract-plugin
export default {"Topp":"price_Topp__FkoY2","use":"price_use__dIKRm","Outa":"price_Outa__UCid2","Inna":"price_Inna__HzGZ4","Free":"price_Free__2yzO1","Firstt":"price_Firstt__Kc7cn"};